import { EOrigenEventoComponent } from '@/common/enums/general.enum';
import {
  IDataPagination,
  IPagination,
} from '@/interface/general/IPagination';
import {
  IResponseApiGenericSS,
  IServerSideBackend,
} from '@/interface/general/IResponseApi';
import { ITable, TypeColumn } from '@/interface/general/ITable';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, lastValueFrom, map, pipe, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IServerSide } from '@/shared/components/general/table-generic/interface/table-generic.interface';
import { HttpParams } from '@angular/common/http';
import { HttpService } from '@/Services/http.service';

@Injectable({
  providedIn: 'root',
})
export class ConsultaExternaPqrsService {
  httpService = inject(HttpService);

  initialConfigTableSubject$ = new BehaviorSubject<ITable | null>(null);
  dataTableGenericSubject$ = new Subject<IDataPagination<IServerSide>>();
  rowsPerPageOptions = environment.paginationLarge;
  rowsPerPage = this.rowsPerPageOptions[0];
  paramsObject: IServerSideBackend = {} as IServerSideBackend;
  currentPagination?: IPagination;
  numeroIdentificacion = 0;

  async setHeaderTable() {
    this.initialConfigTableSubject$.next(this.getTableConfig());
  }

  serverSideDefault = {
    first: 0,
    rows: this.rowsPerPage, // normalmente 10
    sortField: '',
    sortOrder: 1,
    filters: {},
    globalFilter: null,
  };

  getTableConfig(): ITable {
    return {
      fieldId: 'IdPqrs',
      paginator: true,
      rowsPerPageOptions: this.rowsPerPageOptions,
      lazyLoadOnInit: false,
      columns: [
        {
          field: 'IdPqrs',
          label: 'ID',
          type: TypeColumn.NUMBER,
          filter: false,
          sort: false,
        },
        {
          field: 'CodRadicado',
          label: 'CodRadicado',
          type: TypeColumn.STRING,
          filter: true,
          sort: true,
        },
        {
          field: 'Asunto',
          label: 'Asunto',
          type: TypeColumn.STRING,
          filter: true,
          sort: false,
        },
        {
          field: 'DescripcionPqr',
          label: 'Descripcion',
          type: TypeColumn.STRING,
          filter: true,
          sort: true,
        },
        {
          field: 'FechaRadicacion',
          label: 'FechaRadicacion',
          type: TypeColumn.DATE,
          filter: true,
          sort: true,
        },
        {
          field: 'FechaVencimiento',
          label: 'FechaVencimiento',
          type: TypeColumn.DATE,
          filter: true,
          sort: true,
        },
        {
          field: 'EmailUsuarioActualiza',
          label: 'EmailUsuarioActualiza',
          type: TypeColumn.STRING,
          filter: true,
          sort: true,
        },
        {
          field: 'Estado_Texto',
          label: 'Estado_Texto',
          type: TypeColumn.STRING,
          filter: true,
          sort: false,
        },
        {
          field: 'TipoPqr_Texto',
          label: 'TipoPqr_Texto',
          type: TypeColumn.STRING,
          filter: true,
          sort: true,
        },
      ],
    };
  }

  async onLoadRecords(event: any) {
    // let serverSide: IServerSide;
    this.currentPagination = event ?? this.currentPagination;
    const ConsultaPqrsDefault: any = {
      Identificacion: '',
    };
    const data = await lastValueFrom(this.getData());
    this.dataTableGenericSubject$.next(data);
  }

getData(numero?: number) {
  this.numeroIdentificacion = numero ?? this.numeroIdentificacion; // Asignar el número de identificación al atributo de la clase

  const pagination = this.currentPagination ?? this.serverSideDefault;

  const params = new HttpParams()
    .set('Identificacion', this.numeroIdentificacion)
    .set('ServerSide', JSON.stringify(pagination))
    .set('ExportExcel', false);

  return this.httpService
    .GetParams<IResponseApiGenericSS<any>>('PQR/GetPeticionarioByIdentificacion', params)
    .pipe(map((resp) => ({ data: resp.data, totalRecords: resp.metadataServerSide.totalRegitros, pagination })));
  }
}
